import MyTypes from 'MyTypes';
import * as React from 'react';
import { connect } from 'react-redux';
import { Route } from 'react-router';
import { bindActionCreators, Dispatch } from 'redux';

import { Dimmer, Loader, Progress } from 'semantic-ui-react';
import LayoutHeader from '../components/layout-header/LayoutHeader';
import { accountActions } from '../features/account';
import { IUser } from '../models';
import services from '../services';

import PhoneConfirmation from './../components/register-profile/PhoneConfirmation';
import ThankYouPage from './../components/register-profile/ThankYouPage';
import AdminLoginPage from './account/admin-login';
import EmailVerificationPage from './account/email-verify';
import StandbyListQuickSignUp from './account/standbylist-quick-sign-up'
import LoginPage from './account/login';
import RegisterPage from './account/register';
import ResetPassword from './account/reset-password';

interface Props {
  isAuthenticationChecked: boolean;
  isLoading: boolean;
  loadingProgress: number;
  user?: IUser;
  pathname: string;
  checkAuthentication: () => void;
  logout: () => void;
  step: number;
}

interface State {
  showSidebar: boolean;
}

class LayoutComponent extends React.Component<Props, State> {
  public state = {
    showSidebar: false,
  };

  public componentWillMount(): void {
    this.props.checkAuthentication();
  }

  public triggerSidebar = () => {
    this.setState({ showSidebar: !this.state.showSidebar });
  };

  public render() {
    const { user } = this.props;
    if (!this.props.isAuthenticationChecked) {
      return (
        <Dimmer active={true} page={true}>
          <Loader size="massive">Please wait</Loader>
        </Dimmer>
      );
    }
    return (
      <div>
        <LayoutHeader
          user={user}
          logout={this.props.logout}
          step={this.props.step}
          pathname={this.props.pathname}
          triggerSidebar={this.triggerSidebar}
          hideWarningMessage={
            -1 !==
            [
              services.router.url.register,
              services.router.url.login,
              services.router.url.emailVerification,
              services.router.url.profile,
              services.router.url.standbyListQuickSignUp,
            ].indexOf(window.location.pathname)
          }
        />
        <Dimmer active={this.props.isLoading} page={true}>
          {this.props.loadingProgress ? (
            <Progress
              percent={this.props.loadingProgress}
              active={true}
              progress={true}
              style={{ width: '200px' }}
              inverted={true}
            >
              Please wait
            </Progress>
          ) : (
            <Loader size="massive">Please wait</Loader>
          )}
        </Dimmer>

        <Route path={services.router.url.login} component={LoginPage} />
        <Route path={services.router.url.adminLogin} component={AdminLoginPage} />
        <Route path={services.router.url.register} component={RegisterPage} />
        <Route path={services.router.url.resetPasswordPage} component={ResetPassword} />
        <Route path={services.router.url.phoneConfirmation} component={PhoneConfirmation} />
        <Route path={services.router.url.thankYou} component={ThankYouPage} />
        <Route path={services.router.url.emailVerification} component={EmailVerificationPage} />
        <Route path={services.router.url.standbyListQuickSignUp} component={StandbyListQuickSignUp} />
      </div>
    );
  }
}

const mapStateToProps = (state: MyTypes.RootState) => ({
  isLoading: state.loading.loading.isVisible,
  loadingProgress: state.loading.loading.progress,
  pathname: state.router.location.pathname,
  user: state.account.account.user,
  step: state.account.register.step,
  isAuthenticationChecked: state.account.account.isAuthenticationChecked,
});

const mapDispatchToProps = (dispatch: Dispatch) =>
  bindActionCreators(
    {
      checkAuthentication: accountActions.checkAuthentication,
      logout: accountActions.logout,
    },
    dispatch
  );

export const Layout = connect(
  mapStateToProps,
  mapDispatchToProps
)(LayoutComponent);
